import React, { useState } from 'react'
import resolveProps from '../../../utils/resolveProps'
import { ShortcutProps } from './types'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    { title: 'extended' }
  ],
  modifiers: ['inverse', 'secondary'],
  states: ['loading']
}

export default function Shortcut(props: ShortcutProps
  & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  const { icon, loading, children, target, inverse, secondary, href, data, extended, isDetails, ...rest } = props

  return (
    <a
      {...rest}
      className={`${resolveProps(props, config, 'Shortcut')}${loading ? ' mdn-Skeleton' : ''} `}
      href={href}
      target={target}
    > {extended
      ? (<>
        <div className="mdn-Shortcut-container">
          <p className="mdn-Shortcut-text">{data.title}</p>
          <p className="mdn-Shortcut-text-description">{data.content}</p>
          <button className="mdn-Button mdn-Button--iconText mdn-Button--primary">
            <i className={`mdn-Icon-${data.buttonProps.iconName} mdn-Icon--sm`} aria-hidden="true"></i>
            <span>{data.buttonProps.text}</span>
          </button>
        </div>
      </>
      ) :
      isDetails ?        
        (        
        <>
          <span className={icon}></span>
          <p className="mdn-Shortcut-text">{data.title}</p>
          <p className="mdn-Shortcut-text-description">{data.content}</p>
        </>)
        
        // default  shortcut
        : (<>
          <span
            className={`${loading ? 'mdn-Skeleton-item mdn-Skeleton-icon' : 'mdn-Shortcut-icon mdn-Icon-' + icon + ' mdn-Icon--md'}`}
          ></span>
          <p className={`${loading ? 'mdn-Skeleton-item mdn-Skeleton-text' : 'mdn-Shortcut-text '}`}>{!loading ? children : ''}</p>
        </>)}

    </a>
  )
}
